import { ThemeEvents } from '@theme/events';

/**
 * A custom element that displays a promotional offer price.
 * It listens for variant update events and swaps in the offer price markup
 * for the newly selected variant, mirroring how <product-price> updates.
 */
class OfferPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateOfferPrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateOfferPrice);
  }

  /**
   * Updates the offer price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateOfferPrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newContainer = event.detail.data.html.querySelector(
      `offer-price[data-block-id="${this.dataset.blockId}"] [ref="offerPriceContainer"]`
    );
    const currentContainer = this.querySelector('[ref="offerPriceContainer"]');

    if (!newContainer || !currentContainer) return;

    if (currentContainer.innerHTML !== newContainer.innerHTML) {
      currentContainer.replaceWith(newContainer);
    }
  };
}

if (!customElements.get('offer-price')) {
  customElements.define('offer-price', OfferPrice);
}
